// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__2DUPv","active":"Uploader_active__3_kP_"};